import { render } from "./PersonasCompare.vue?vue&type=template&id=8d64a870&scoped=true"
import script from "./PersonasCompare.vue?vue&type=script&lang=js"
export * from "./PersonasCompare.vue?vue&type=script&lang=js"

import "./PersonasCompare.vue?vue&type=style&index=0&id=8d64a870&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d64a870"]])

export default __exports__